import * as React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export const PasteNormalizerPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    return editor.registerCommand(
      // 64 is COPY Verging; use paste listener via root event for simplicity
      // We attach DOM-level 'paste' to normalize basic content.
       
      (null as any),
      () => true,
      0
    );
  }, [editor]);

  React.useEffect(() => {
    const root = editor.getRootElement();
    if (!root) return;
    const onPaste = (e: ClipboardEvent) => {
      try {
        // Prefer plain text for now; keep line breaks
        const text = e.clipboardData?.getData('text/plain');
        if (text) {
          e.preventDefault();
          editor.update(() => {
            document.execCommand('insertText', false, text);
          });
          return;
        }
      } catch {}
    };
    root.addEventListener('paste', onPaste);
    return () => root.removeEventListener('paste', onPaste);
  }, [editor]);

  return null;
};












